import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d7b0ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nameField" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, null, -1))
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "emailField" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hr" }, null, -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button solidButton",
    type: "submit",
    tabindex: "4"
  }, "Soutěžit")
], -1))

import { computed } from 'vue'
import { useStore } from 'vuex'
import { useForm, useField } from 'vee-validate'
import { object, string, bool } from 'yup'
import ConsentCheckbox from './ConsentCheckbox.vue'
import { questions } from '@/textConfig'
import submitForm from '@/submitForm'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { VUE_APP_SUBMIT_REDIRECT_URL } = process.env

const store = useStore()

const { errors, handleSubmit } = useForm({
  validationSchema: object({
    name: string()
      .required('Pole je povinné.')
      .min(5, 'Pole musí obsahovat aspoň 5 znaků.')
      .max(50, 'Pole musí obsahovat 50 a&nbsp;méně znaků.'),
    email: string()
      .required('Pole je povinné.')
      .email('Pole musí obsahovat validní email.')
      .max(50, 'Pole musí obsahovat 50 a&nbsp;méně znaků.'),
    consent: bool().oneOf([true], 'Pole musí být označené.'),
  }),
  initialValues: {
    name: '',
    email: '',
    consent: false,
  },
})

const { value: name } = useField<string>('name')
const { value: email } = useField<string>('email')
const { value: consent } = useField<boolean>('consent')

const hideName = computed(() => name.value.length === 0)
const hideEmail = computed(() => email.value.length === 0)

const submit = handleSubmit(() => {
  const questionsPayload = questions.map((q) => ({
    question: q.question,
    answer: q.answer,
    description: q.description,
  }))
  const payload = {
    name: name.value,
    email: email.value,
    correctAnswers: [...(store.state.answers as boolean[])],
    questions: questionsPayload,
  }
  submitForm(payload)
    .then(() => window.open(VUE_APP_SUBMIT_REDIRECT_URL, '_self'))
    .catch(() => window.open(VUE_APP_SUBMIT_REDIRECT_URL, '_self'))
  // Replace window.open with this line if you want final "clap" screen again
  // store.commit('submit')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(submit) && _unref(submit)(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["alt-placeholder", { hideName: _unref(hideName) }])
      }, "Jméno a příjmení", 2),
      _withDirectives(_createElementVNode("input", {
        id: "name",
        type: "text",
        placeholder: "Jméno a příjmení",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
        tabindex: "1"
      }, null, 512), [
        [_vModelText, _unref(name)]
      ]),
      _hoisted_2,
      _createElementVNode("div", {
        class: "error",
        innerHTML: _unref(errors).name
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["alt-placeholder", { hideEmail: _unref(hideEmail) }])
      }, "Emailová adresa", 2),
      _withDirectives(_createElementVNode("input", {
        id: "email",
        type: "text",
        placeholder: "Emailová adresa",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
        tabindex: "2"
      }, null, 512), [
        [_vModelText, _unref(email)]
      ]),
      _hoisted_5,
      _createElementVNode("div", {
        class: "error",
        innerHTML: _unref(errors).email
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", null, [
      _createVNode(ConsentCheckbox, {
        modelValue: _unref(consent),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(consent) ? (consent).value = $event : null))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", {
        class: "error error-consent",
        innerHTML: _unref(errors).consent
      }, null, 8, _hoisted_7)
    ]),
    _hoisted_8
  ], 32))
}
}

})